import React from "react";
import AllVendors from "./VendorModule/AllVendors";
const Vendors = () => {
  return (
    <div>
      <AllVendors />
    </div>
  );
};

export default Vendors;
